module.exports = __webpack_public_path__ + "static/img/lab_1.b6247f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lab_1.png
// module id = GoA+
// module chunks = 1